var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"student-avatar",style:(_vm.rootStyle)},[(!_vm.avatar)?_c('span',[_vm._v(_vm._s(_vm.computedInitials))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }